import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { DISPLAYED_NAME } from "../../../utils/enums";
import { getDisplayedName } from "../../../utils/help/localization/localization";
import { ItemType } from "../../../utils/types";
import styles from "./ItemName.module.scss";
import { wordsLowerCaseInItemName } from "./ItemNameHelper";

export const ItemName = (props: { item: ItemType; prefix?: string }) => {
  const { item } = props;

  const letterUppercase = (str: string) => {
    const firstChar = str.charAt(0).toUpperCase();
    const remainingChars = str.slice(1);

    return `${firstChar}${remainingChars.toLowerCase()}`;
  };

  const ignoreNameFormats = useAppSelector(
    (state) => state.config.restaurantConfig?.ignoreNameFormats
  );

  const itemName = () => {
    if (ignoreNameFormats) {
      return getDisplayedName(item, DISPLAYED_NAME.ITEM_NAME) || "";
    }
    const name: string = getDisplayedName(item, DISPLAYED_NAME.ITEM_NAME) || "";
    const words = name?.split(" ");
    if (words) {
      for (let i = 0; i < words.length; i++) {
        const lowercaseWord = words[i].toLowerCase();
        wordsLowerCaseInItemName().map((word) => {
          let finalString;

          if (word.toLowerCase() === lowercaseWord) {
            finalString = words[i] = lowercaseWord;
          }

          return finalString;
        });
      }
    }

    const modifiedName = words ? words.join(" ") : name.toLowerCase();

    return props.prefix
      ? props.prefix + " " + letterUppercase(modifiedName)
      : letterUppercase(modifiedName);
  };

  return (
    <p
      className={`${styles.name} ${
        itemName().length > 35 && styles.name__small
      }`}
    >
      {itemName()}
    </p>
  );
};
